<span [ngClass]="{dlFadeIn: sidebarService.sidebarHasOpend | async}">
  <ng-content></ng-content>
</span>